




export default {
  name: "BaseBreadcrumb",
  props: {
    items: {
      type: Array,
      default: () => [
        {
          text: this.$t("Locatie.title")
        }
      ]
    }
  },
  computed: {
    baseWithItems() {
      return [
        {
          text: this.$t("shared.home"),
          to: { name: "Home" }
        },
        ...this.items
      ];
    }
  }
};
